import React, { useEffect } from "react";
import "./App.css";

import MyNavbar from "../components/MyNavbar/MyNavbar";
import MyFooter from "../components/MyFooter/MyFooter";

import { digitalDrawings } from "../img/digitaldrawing";
import { ImageList, ImageListItem, ImageListItemBar, Stack, Typography } from "@mui/material";

function Hobbies() {
  useEffect(() => {
    document.title = "Chun Yen Chang-Sundin";
  });
  return (
    <div className="App">
      <MyNavbar />
      <main className="main-frame">
        <Stack direction={"column"} maxWidth={1320} mx="auto" px={2} spacing={2} mb={2}>
          <Stack direction={'column'} spacing={1}>
            <Typography variant={"h5"}>Fitness & Health</Typography>
            <div>Being active and taking care of my health matters to me, and over time it’s taught me the value of consistency and discipline. It’s a reminder that real progress comes from steady effort — more of a long-distance run than a quick sprint.</div>
          </Stack>
          <Stack direction={"column"} spacing={1}>
            <Typography variant={"h5"}>Digital Drawing</Typography>
            <div>
              Working with digital art has sharpened my sense of color, composition, and visual structure, and those skills carry over directly into front-end work — from choosing harmonious palettes to arranging layouts and improving overall UI intuition.
            </div>
            <ImageList cols={4} sx={{  borderRadius: 3 }}>
              {digitalDrawings.map((img) => (
                <ImageListItem key={img.key} sx={{height: {sm: 200, md: 400}}}>
                  <img 
                    src={`${img.src}?w=150&h=150&fit=cover&auto=format`} 
                    alt={img.title} 
                    loading="lazy" />
                  <ImageListItemBar 
                    position="bottom" 
                    title={img.title} 
                    subtitle={img.description} />
                </ImageListItem>
              ))}
            </ImageList>
          </Stack>
        </Stack>
      </main>
      <MyFooter />
    </div>
  );
}

export default Hobbies;
